import Figure from "~/components/figure"
import fetchGradients from "~/components/circuit/fetchGradients"
import { Spinner, Icon } from "evergreen-ui"
import Tiles from "~/components/tiles"
import { scaleLinear } from "d3-scale"
import { range } from "lodash"

export default class CurveTiles extends Component {
  state = { weights: null }

  componentWillMount() {
    fetchGradients("inceptionv1", "mixed3a", "mixed3b").then(weights => {
      this.setState({ weights })
    })
  }

  render() {
    const { weights } = this.state
    const { size = 120 } = this.props
    const scale = scaleLinear().domain([0, 40])

    if (!weights) {
      return <Spinner />
    }
    const upstream = [189, 81, 104, 92, 145, 95, 163, 71, 147]
    const neurons = [406, 385, 343, 342, 388, 324, 340, 330, 349, 379]

    return (
      <Surface gridColumn="screen" marginY={20}>
        <Surface flexFlow="row" alignSelf="center">
          {range(upstream.length).map(index => (
            <Surface marginX={10}>
              <Surface
                flexFlow="row"
                alignItems="center"
                marginBottom={5}
                alignSelf="center"
              >
                <ZoomedImg
                  size={48}
                  padding={20}
                  src={neuronFeatureVis(
                    "inceptionv1",
                    "mixed3a",
                    upstream[index],
                  )}
                />
                <Icon icon="arrow-right" opacity={0.7} marginX={5} />
                <ZoomedImg
                  size={48}
                  padding={5}
                  src={neuronFeatureVis(
                    "inceptionv1",
                    "mixed3b",
                    neurons[index],
                  )}
                />
              </Surface>
              <Surface border>
                <Tiles
                  size={size}
                  grad={weights[upstream[index]][neurons[index]]}
                  hasBorder={false}
                  scale={scale}
                />
              </Surface>
            </Surface>
          ))}
        </Surface>
      </Surface>
    )
  }
}
